import { Observable } from "rxjs";
import { Response } from "@angular/http";
import { Injectable } from "@angular/core";

import * as CryptoJS from "crypto-js";

import { URLSearchParams } from '@angular/http'
import { HttpBackendService } from "app/services/http-backend.service";
import { UserSelf } from "app/models/userSelf";
import { Client } from "app/models/client";

const authenticatedUserKey = "authenticatedUser";

@Injectable()
export class ProfileService {

  constructor(private _http: HttpBackendService)
  { }


  changePassword(password: string, newPassword: string): Observable<null> {

    let passwordHash = CryptoJS.SHA256(password);
    let newPasswordHash = CryptoJS.SHA256(newPassword);

    return this._http.post(`/api/user/changePassword`,
      {
        PasswordHash: passwordHash.toString(CryptoJS.enc.Base64),
        NewPasswordHash: newPasswordHash.toString(CryptoJS.enc.Base64),
      },
      null,
      true)
      .catch(err => {
        if (err instanceof Response) {
          let response = err as Response;
          return Observable.throw(this.resolveChangePasswordError(response));
        }
        return Observable.throw("Unknown" as ProfileService.ChangePasswordError);
      });
  }

  checkHasCallConfirmationPermission(): boolean {
    let authenticatedUserJson = localStorage.getItem(authenticatedUserKey);
    let user = authenticatedUserJson ? Object.assign(Object.create(UserSelf.prototype), JSON.parse(authenticatedUserJson)) : null

    if (!user)
      throw new Error('User not found');

    return user.client.callConfirmation;
  }

  checkHasAccessPhotoPermission(): boolean {
    let authenticatedUserJson = localStorage.getItem(authenticatedUserKey);
    let user = authenticatedUserJson ? Object.assign(Object.create(UserSelf.prototype), JSON.parse(authenticatedUserJson)) : null

    if (!user)
      throw new Error('User not found');

    return user.client.canAccessPhotos;
  }

  checkHasAccessReportsPermission(): boolean {
    let authenticatedUserJson = localStorage.getItem(authenticatedUserKey);
    let user = authenticatedUserJson ? Object.assign(Object.create(UserSelf.prototype), JSON.parse(authenticatedUserJson)) : null

    if (!user)
      throw new Error('User not found');

    return user.client.canAccessReports;
  }

  checkHasAccessSurveysPermission(): boolean {
    let authenticatedUserJson = localStorage.getItem(authenticatedUserKey);
    let user = authenticatedUserJson ? Object.assign(Object.create(UserSelf.prototype), JSON.parse(authenticatedUserJson)) : null

    if (!user)
      throw new Error('User not found');

    return user.client.canAccessSurveys;
  }

  activateUser(newPassword: string, token: string): Observable<null> {

    let newPasswordHash = CryptoJS.SHA256(newPassword);

    return this._http.post(`/api/user/activate`,
      {
        Token: token,
        PasswordHash: newPasswordHash.toString(CryptoJS.enc.Base64),
      },
      null,
      false)
      .catch(err => {
        if (err instanceof Response) {
          let response = err as Response;
          return Observable.throw(this.resolveActivateTokenError(response));
        }
        return Observable.throw("Unknown" as ProfileService.ActivateTokenError);
      });
  }

  resetPassword(newPassword: string, token: string): Observable<null> {

    let newPasswordHash = CryptoJS.SHA256(newPassword);

    return this._http.post(`/api/user/restore/resetPassword`,
      {
        Token: token,
        PasswordHash: newPasswordHash.toString(CryptoJS.enc.Base64),
      },
      null,
      false)
      .catch(err => {
        if (err instanceof Response) {
          let response = err as Response;
          return Observable.throw(this.resolveActivateTokenError(response));
        }
        return Observable.throw("Unknown" as ProfileService.ActivateTokenError);
      });
  }

  restoreUser(username: string): Observable<string> {
    return this._http.get("/api/user/restore?username=" + username, null , false)
      .map(resp => resp.text());
  }


  private resolveChangePasswordError(response: Response): ProfileService.ChangePasswordError {
    let body: any;
    let errorCode: number;
    switch (response.status) {
      case 400:
        body = null;
        try {
          body = response.json();
        } finally { }
        errorCode = body && body.ErrorCode ? body.ErrorCode : null;
        switch (errorCode) {
          case 4:
            return "InvalidPasword";
        }
        break;
    }
    return "Unknown";
  }

  private resolveActivateTokenError(response: Response): ProfileService.ActivateTokenError {
    let body: any;
    let errorCode: number;
    switch (response.status) {
      case 403:
        body = null;
        try {
          body = response.json();
        } finally { }
        errorCode = body && body.ErrorCode ? body.ErrorCode : null;
        switch (errorCode) {
          case 5:
            return "UserIsActivated";
          case 6:
            return "TemporaryTokenDateIsExpired";
          case 8:
            return "UserWithEmailExist";
        }
        break;
    }
    return "Unknown";
  }

}


export namespace ProfileService {
  export type ChangePasswordError = ("Unknown" | "InvalidPasword");
  export type ActivateTokenError = ("Unknown" | "UserIsActivated" | "TemporaryTokenDateIsExpired" | "UserWithEmailExist");
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/profile.service.ts